import React, { Component } from 'react';
import { Col, Row, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSms } from '@fortawesome/free-solid-svg-icons';
import Input from '../../../Input';
import { PulseLoader } from 'react-spinners';
import './tercerFactor.css';
import { isEmpty, isNumeric, isLengthSmsOk } from '../../../../utils/ValidationUtil';


class TercerFactor extends Component {

    componentDidMount() {
        const { getSMSChallenge } = this.props;
        getSMSChallenge();
    }

    handleValidateClick = e => {
        e.preventDefault();
        const { validateSMSChallenge, challengeResponse, changeErrorMessage } = this.props;
        if(isEmpty(challengeResponse)){
            changeErrorMessage("El campo no puede estar vacío");
        }else if(!isNumeric(challengeResponse)){
            changeErrorMessage("El campo debe ser numérico");
        }else if(!isLengthSmsOk(challengeResponse)){
            changeErrorMessage("El código debe tener 6 dígitos");
        }else{
            validateSMSChallenge(challengeResponse);
        }
      };

    render() { 

        const { isLoading, 
                errorInput, 
                operation, 
                errorMessage, 
                changeErrorMessage, 
                challengeResponse,
                isExpired,
                isBloqued,
                isSmsRequestValid,
                openErrorModal,
                closeChallenge } = this.props;

        if(!errorInput){
            changeErrorMessage("El código de seguridad ingresado es incorrecto. Favor intente nuevamente");
        }
        if(isExpired){
            closeChallenge();
            openErrorModal("El código de seguridad ha expirado. Favor intente nuevamente", "error");
        }
        if(isBloqued){
            closeChallenge();
            openErrorModal("El código de seguridad ha sido bloqueado. Para desbloquear, por favor contactarse al 600 200 1200", "error");
        }

        return ( 
            <Row>
                {!isSmsRequestValid &&
                    <Col className="tercer-factor">
                        <div className="dap_loader-center">
                            <PulseLoader size={20} color="#d64b36" />
                        </div>
                    </Col>
                }
                {isSmsRequestValid &&
                    <Col className="tercer-factor">
                        <h6>
                            Ingresa código SMS para confirmar la operación <b>{operation}</b>:
                        </h6>
                        <Form>
                            <Form.Group 
                                as={Row}
                                controlId="smsCode"
                                className="justify-content-center"
                            >
                                <Col md={2} sm={2} xs={12}>
                                    <FontAwesomeIcon icon={faSms} />
                                </Col>
                                <Col md={6} sm={6} xs={6}>
                                    <Input
                                        value={challengeResponse}
                                        maxLength={6}
                                        width="100%"
                                        helpText="Código SMS"
                                        onChange = {e =>{
                                            const { changeSMSChallengeResponse } = this.props;
                                            changeSMSChallengeResponse(e.target.value.trim());
                                        }}
                                        onFocus={() => {
                                            const { removeError, changeErrorMessage } = this.props;
                                            changeErrorMessage("");
                                            removeError();
                                        }}
                                        type="password"
                                        errorText={errorMessage}
                                        
                                    />
                                </Col>
                            </Form.Group>
                            {!isLoading &&
                                <Button
                                    type="submit"
                                    onClick={this.handleValidateClick}
                                    className="dap_btn-primary"
                                >
                                    Validar
                                </Button>
                            }
                            {isLoading &&
                                <div className="dap_loader-center">
                                    <PulseLoader size={20} color="#d64b36" />
                                </div>
                            }
                            
                        </Form>
                    </Col>
                }
            </Row>
        );
    }
}
 
export default TercerFactor;